<section class="bh" *ngIf="!loading; else loadingTpl">
    <ng-container *ngIf="frames.length; else emptyTpl">
        <header class="bh__head">
            <div>
                <h3 class="bh__name">{{ beingName }}</h3>
                <p class="bh__sub">
                    {{ frames.length }} observations ·
                    {{ conceptRows.length }} concepts ·
                    {{ alive ? 'alive' : 'died at tick ' + (deathTick ?? '?') }}
                </p>
            </div>
            <dl class="bh__genome">
                <div *ngFor="let g of genomeRows">
                    <dt>{{ g.k }}</dt>
                    <dd>{{ g.v | number: '1.2-2' }}</dd>
                </div>
            </dl>
        </header>

        <figure class="bh__chart">
            <svg [attr.viewBox]="'0 0 ' + CHART_W + ' ' + CHART_H" width="100%" role="img"
                [attr.aria-label]="chartAria">
                <line class="bh__axis" [attr.x1]="PAD_L" [attr.y1]="CHART_H - PAD_B" [attr.x2]="CHART_W - PAD_R"
                    [attr.y2]="CHART_H - PAD_B" />

                <g *ngIf="saturationX !== null">
                    <line class="bh__satline" [attr.x1]="saturationX" [attr.y1]="PAD_T" [attr.x2]="saturationX"
                        [attr.y2]="CHART_H - PAD_B" />
                    <text class="bh__satlabel" [attr.x]="saturationX + 6" [attr.y]="PAD_T + 10">
                        last new concept
                    </text>
                </g>

                <path *ngFor="let s of series" class="bh__line" [attr.d]="s.path" [attr.stroke]="s.color" fill="none" />

                <text class="bh__tick" [attr.x]="PAD_L" [attr.y]="CHART_H - 6">
                    birth
                </text>
                <text class="bh__tick" [attr.x]="CHART_W - PAD_R" [attr.y]="CHART_H - 6" text-anchor="end">
                    obs {{ frames.length }}
                </text>
            </svg>

            <figcaption class="bh__legend">
                <span *ngFor="let s of series" class="bh__key">
                    <i [style.background]="s.color"></i>
                    {{ s.label }}
                    <b>{{ s.format(s.last) }}</b>
                    <em>{{ s.format(s.min) }}–{{ s.format(s.max) }}</em>
                </span>
                <span class="bh__note">each series scaled to its own range</span>
            </figcaption>
        </figure>

        <div class="bh__findings">
            <article *ngFor="let f of findings" [class.bh--flag]="f.flag">
                <h4>{{ f.title }}</h4>
                <p>{{ f.body }}</p>
            </article>
        </div>

        <table class="bh__table">
            <caption>
                Concepts held, most reinforced first
            </caption>
            <thead>
                <tr>
                    <th scope="col">Concept</th>
                    <th scope="col">Seen</th>
                    <th scope="col">Confidence</th>
                    <th scope="col">Avg POIs</th>
                    <th scope="col">Span</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let c of conceptRows" [class.bh--singleton]="c.occurrenceCount === 1">
                    <td>{{ c.id }}</td>
                    <td>{{ c.occurrenceCount }}</td>
                    <td>{{ c.confidence | number: '1.2-2' }}</td>
                    <td>{{ c.avgPoiDensity | number: '1.1-1' }}</td>
                    <td>{{ spanOf(c) }}</td>
                </tr>
            </tbody>
        </table>
    </ng-container>
</section>

<ng-template #loadingTpl>
    <p class="bh__state">Reading observation history…</p>
</ng-template>
<ng-template #emptyTpl>
    <p class="bh__state">
        This being has no stored observations yet. It will appear here after its
        first tick.
    </p>
</ng-template>